import React, { useState, useEffect, useRef } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
import format from "date-fns/format";
import { DateRange } from "react-date-range";

//final home page import section
import impactPlayerBackgroundImage from "../images/Impact_player_screen/home_screen/background.gif";
import backgroundImage from "../images/Impact_player_screen/home_screen/background.gif";


import myRankBGImage from "../images/Impact_player_screen/home_screen/Border_daily_points.png";

import ImpactPlayerLeaderboard from "./ImpactPlayerLeaderboard";

function ImpactPlayerPage() {
  const [cookies] = useCookies(["user"]);
  const user_id = cookies.user_id;
  const token = cookies.token;
  let history = useHistory();
  const [loader, setLoader] = useState("true");
    const [secondSlide, setSecondSlide] = useState(null);
    const [astraActive, setAstraActive] = useState("active");
    const [borActive, setBorActive] = useState("");
    const [slideMarker, setSlidemarker] = useState("");
    const timerComponents2 = [];
  
  const [sortedDateRangeBreakupHtmlData, setSortedDateRangeBreakupHtmlData] =
    useState(null);
  const [sortedDateBreakupHtmlData, setSortedDateBreakupHtmlData] =
    useState(null);
    const [warStatus, setWarStatus] = useState(null);
    const [warData, setWarData] = useState(null);
    const [congratsPoints, setCongratsPoints] = useState(null);

  useEffect(() => {
    callBORApi();
    getPointsBreakup();
    
    const interval = setInterval(() => {
			let timeLt = timeLeftToIW();
			// console.log(timeLt);
			setTimeLeft(timeLt);
		}, 1000);

        const interval2 = setInterval(() => {
			let timeLt2 = timeLeftToIW2();
			// console.log(timeLt);
			setTimeLeft2(timeLt2);
		}, 1000);
  }, []);
  const slide1 = useRef(null);
  const slide2 = useRef(null);

    async function callBORApi() {
        const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
                body: JSON.stringify({dist_user_id:user_id}),
                
            };
        const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-bor-data', requestOptions);
        const res = await response.json();
        if (res.status !== "success" || res.data.k_id == "NA"){
            // setError(true);
            console.log('error1');
        }
        setWarData(res.data);
        setWarStatus(res.data.show_5x);
        localStorage.setItem('war_status', res.data.show_5x);
        if(res.data.show_5x){
            localStorage.setItem('slide', '2');
            setAstraActive("");
            setBorActive("active");
            let trend = "at a standstill"
            if(res.data.name == res.data.kd1_name){
                if(res.data.kd1_points > res.data.kd2_points){
                    trend = "leading"
                }else if(res.data.kd1_points < res.data.kd2_points) {
                    trend = "trailing"
                }
            } else {
                if(res.data.kd1_points > res.data.kd2_points){
                    trend = "trailing"
                }else if(res.data.kd1_points < res.data.kd2_points) {
                    trend = "leading"
                }
            }
            setSlidemarker("0");
            setSecondSlide(
                <Link to={{
                    pathname:"/war-score",
                    state: [res.data, '']
                }} key="secsli1" className="carousel-item bkb">
                    <div
                        className="align-items-center justify-content-center slide_2"
                        style={{
                        backgroundImage: `url(${
                            require("../images/Impact_player_screen/Onboarding_screen/live_war.gif")
                            .default
                        })`,
                        backgroundSize: "100% 100%",
                        }}
                    >
                        <div className="battle_of_region text-white text-center">BATTLE OF REGIONS </div>
                        <div className="battle_no text-white text-center">BATTLE NO. {res.data.battle_no} </div>
                        <div className='teams'>
                            <div className="team_1 text-white text-center">
                            <span>{res.data.kd1_name}</span>
                            </div>
                            <div style={{width:'20%'}}></div>
                            <div className="team_2 text-white text-center"><span>{res.data.kd2_name}</span> </div>
                        </div>
                        <div className="leading_text text-white text-center">Your Region is {trend}. </div>
                        <div className="live_text text-white text-center">
                        <img src={require("./../images/Impact_player_screen/live.png").default} alt="alt" style={{height:'1.5em'}} />
                        </div>
                    </div>
                </Link>
            );
        } else if(res.data.start_date !== ""){
            localStorage.setItem('slide', '2');
            setAstraActive("");
            setBorActive("active");
            setSlidemarker("1");
            localStorage.setItem("warStartTime", res.data.start_date);
        } else {
            localStorage.setItem('slide', '1');
            setSecondSlide(
                <div key="secsli3" className="carousel-item bkb">
                    <div
                        className="align-items-center justify-content-center slide_4"
                        style={{
                        backgroundImage: `url(${
                            require("../images/Impact_player_screen/Onboarding_screen/normal_day.png")
                            .default
                        })`,
                        backgroundSize: "100% 100%",
                        }}
                    >
                        <div className="slider_point_1 text-white">
                            <span>{res.data.wars_won}</span>
                        </div>
                        <div className="slider_point_2 text-white">
                            <span>{res.data.rank}</span>
                        </div>
                        <div className="slider_bottom_link text-white text-center">
                            <Link to={{
                                pathname:"/region-home"
                            }} style={{color:"white"}}>View Today's War</Link> 
                        </div>
                    </div>
                </div> 
            );
        }
    }
  const timerComponents = [];
    const timeLeftToIW = () => {
		let wet = localStorage.getItem("iwtime");
		const difference = +new Date(wet) - +new Date();
		let timeLeft = {};
		if (difference > 0) {
			timeLeft = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) %24 ),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				seconds: Math.floor((difference / 1000) % 60),
			};
		} else {
			return {'no':1};
		}
		return timeLeft;
	};
    const timeLeftToIW2 = () => {
		let wet = localStorage.getItem("warStartTime");
		const difference = +new Date(wet) - +new Date();
		let timeLeft = {};
		if (difference > 0) {
			timeLeft = {
				// days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60))),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				seconds: Math.floor((difference / 1000) % 60),
			};
		} else {
			return {'no':1};
		}
		return timeLeft;
	};
    const [timeLeft, setTimeLeft] = useState(timeLeftToIW());
    const [timeLeft2, setTimeLeft2] = useState(timeLeftToIW2());

    let i =10000;
    Object.keys(timeLeft).forEach((interval) => {
		if(interval === 'no'){
			timerComponents.push("");
			return;
		}
		if (!timeLeft[interval] && timeLeft[interval] != 0) {
		  return;
		}
        let a = timeLeft[interval];
        if(interval === 'days'){
			timerComponents.push(
                <div key={"1"+i}><div>{a}</div><div className='font-x-small'>Days</div></div>
            );
            timerComponents.push(
                <div key={"2"+i} className='timer-seprator'></div>  
            );
		}
        if(interval === 'hours'){
            timerComponents.push(
                <div key={"3"+i}><div>{a}</div><div className='font-x-small'>Hours</div></div>
            );
            timerComponents.push(
                <div key={"4"+i} className='timer-seprator'></div>  
            );
		}
        if(interval === 'minutes'){
			timerComponents.push(
                <div key={"5"+i}><div>{a}</div><div className='font-x-small'>Min</div></div>
            );
            timerComponents.push(
                <div key={"6"+i} className='timer-seprator'></div>  
            );
		}
        if(interval === 'seconds'){
			timerComponents.push(
                <div key={"7"+i}><div>{a}</div><div className='font-x-small'>Sec</div></div>
            );
		}
		i++;
	});

    let j =10000;
    Object.keys(timeLeft2).forEach((interval2) => {
		if(interval2 == 'no'){
            timerComponents2.push("");
            return;
        }
        if (!timeLeft[interval2] && timeLeft[interval2] != 0) {
          return;
        }
        let a = timeLeft2[interval2];
        if(interval2 == 'hours'){
            timerComponents2.push(
                <a key={j}>
                    {a}{" hours : "}
                </a>
            );
        }
        if(interval2 == 'minutes'){
            timerComponents2.push(
                <a key={j}>
                    {a}{" mins : "}
                </a>
            );
        }
        if(interval2 == 'seconds'){
        	timerComponents2.push(
                <a key={j}>
                    {a}{" secs"}
                </a>
            );
        }
		j++;
	});

  // pointsBreakup.targets_data.retailer.percentage
  const [pointsBreakup, setPointsBreakup] = useState({
    status: "failuer",
    dmt: 0,
    micro_atm: 0,
    aeps: 0,
    recharge: 0,
    other: 0,
    month_total: 0,
    targets_data: { retailer: {}, sale: {}, service: {} },
  });
  const [dateBreakup, setDateBreakup] = useState({
    dmt: 0,
    micro_atm: 0,
    aeps: 0,
    recharge: 0,
    other: 0,
    bonus: 0,
  });
  const [dateRangeBreakup, setDateRangeBreakup] = useState({
    dmt: 0,
    micro_atm: 0,
    aeps: 0,
    recharge: 0,
    other: 0,
    bonus: 0,
  });
  const [dailyPts, setDailyPts] = useState(0);
  const [milestone, setMilestone] = useState({
    a: "0%",
    b: "0%",
    c: "0%",
    d: "0%",
    e: "0%",
    f: "0%",
    g: "0%",
    h: "0%",
    i: "0%",
    j: "0%",
    l1: require("./../images/1l-inact.svg").default,
    l3: require("./../images/3l-inact.svg").default,
    l10: require("./../images/10l-inact.svg").default,
    l25: require("./../images/25l-inact.svg").default,
  });
  const [error1, setError] = useState(false);
  const [desc, setDesc] = useState("");
  const inputRef = React.useRef(null);
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [range1, setRange1] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const refOne = useRef(null);
  const [miDate, setMiDate] = useState(new Date(1970, 1, 1));
  const [maDate, setMaDate] = useState(new Date());
  const [achievingMilestone, setAchievingMilestone] = useState({});

  const [saleTargetDisplay, setSaleTargetDisplay] = useState("");
  const [serviceTargetDisplay, setServiceTargetDisplay] = useState("");
  const [retailerTargetDisplay, setRetailerTargetDisplay] = useState(
    <div key="ret1"></div>
  );

  const getPointsBreakup = async () => {
    localStorage.setItem("pbsd", "");
    localStorage.setItem("pbed", "");
    var tmp = new Date();
    localStorage.setItem("pbs", format(tmp, "yyyy-MM-dd"));
    localStorage.setItem("pbe", format(tmp, "yyyy-MM-dd"));
    localStorage.setItem("d", "");
    localStorage.setItem("noSk", "0");
    newDateRange();
  };

  async function newDateRange() {
    console.log("---------------------");
    // console.log(format(range[0].startDate, "yyyy-MM-dd"));
    var sDate = localStorage.getItem("pbs");
    var eDate = localStorage.getItem("pbe");
    localStorage.setItem("clickCnt", 0);
    let type = "";
    if (localStorage.getItem("d") === "1") {
      type = "1";
    } else if (localStorage.getItem("d") === "0") {
      type = "0";
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
        userId: user_id,
      },
      body: JSON.stringify({
        dist_user_id: user_id,
        start_date: sDate,
        end_date: eDate,
        new_ui: "true",
      }),
    };

    const response = await fetch(
      process.env.REACT_APP_BKB_URL_DOMAIN + "get-all-distributor-home-data",
      requestOptions
    );
    const data = await response.json();

    if (data.status !== "success") {
      setDesc(data.desc);
      inputRef.current.click();
      if (type === "1") {
        setRange1([
          {
            startDate: new Date(localStorage.getItem("pbsd")),
            endDate: new Date(localStorage.getItem("pbed")),
            key: "selection",
          },
        ]);
      } else {
        setRange([
          {
            startDate: new Date(localStorage.getItem("pbsd")),
            endDate: new Date(localStorage.getItem("pbed")),
            key: "selection",
          },
        ]);
      }
      localStorage.setItem("pbs", localStorage.getItem("pbsd"));
      localStorage.setItem("pbe", localStorage.getItem("pbed"));
      // console.log(error1);
    } else {
      localStorage.setItem("pbsd", sDate);
      localStorage.setItem("pbed", eDate);
      let pts = data.total_points.replaceAll(",", "");
      localStorage.setItem("iwtime", data.impact_warrior_till + " 23:59:59");
      console.log('data.impact_warrior_till')
      console.log(data.impact_warrior_till)
      for (const el of data.season_data.milestone) {
        if (pts < el.points) {
          setAchievingMilestone({
            acheive: el.points - pts,
            voucher: el.desc_line1 + ' ' +el.desc_line2,
          });
          break; // This will exit the loop
        }
      }
      console.log(pts);
      if (pts <= 100000) {
        let perc = (pts * 100) / 100000;
        setMilestone({
          a: perc + "%",
          b: "0%",
          c: "0%",
          d: "0%",
          e: "0%",
          f: "0%",
          g: "0%",
          h: "0%",
          i: "0%",
          j: "0%",
          l1: require("./../images/BKB-Elements/Milestone 1L.svg").default,
          l3: require("./../images/BKB-Elements/Milestone 5L.svg").default,
          l10: require("./../images/BKB-Elements/Milestone 10L.svg").default,
          l25: require("./../images/BKB-Elements/Milestone 25L.svg").default,
        });
      } else if (pts > 100000 && pts <= 500000) {
        let perc = ((pts - 100000) * 100) / 400000;
        setMilestone({
          a: "100%",
          b: "0%",
          c: perc + "%",
          d: "0%",
          e: "0%",
          f: "0%",
          g: "0%",
          h: "0%",
          i: "0%",
          j: "0%",
          l1: require("./../images/BKB-Elements/Milestone 1L.svg").default,
          l3: require("./../images/BKB-Elements/Milestone 5L.svg").default,
          l10: require("./../images/BKB-Elements/Milestone 10L.svg").default,
          l25: require("./../images/BKB-Elements/Milestone 25L.svg").default,
        });
      } else if (pts > 500000 && pts <= 1000000) {
        let perc = ((pts - 500000) * 100) / 500000;
        setMilestone({
          a: "100%",
          b: "0%",
          c: "100%",
          d: "0%",
          e: perc + "%",
          f: "0%",
          g: "0%",
          h: "0%",
          i: "0%",
          j: "0%",
          l1: require("./../images/BKB-Elements/Milestone 1L.svg").default,
          l3: require("./../images/BKB-Elements/Milestone 5L.svg").default,
          l10: require("./../images/BKB-Elements/Milestone 10L.svg").default,
          l25: require("./../images/BKB-Elements/Milestone 25L.svg").default,
        });
      } else if (pts > 1000000 && pts <= 2500000) {
        let perc = ((pts - 1000000) * 100) / 1500000;
        setMilestone({
          a: "100%",
          b: "0%",
          c: "100%",
          d: "0%",
          e: "100%",
          f: "0%",
          g: perc + "%",
          h: "0%",
          i: "0%",
          j: "0%",
          l1: require("./../images/BKB-Elements/Milestone 1L.svg").default,
          l3: require("./../images/BKB-Elements/Milestone 5L.svg").default,
          l10: require("./../images/10l-act.svg").default,
          l25: require("./../images/BKB-Elements/Milestone 25L.svg").default,
        });
      } else {
        let perc = ((pts - 2500000) * 100) / 2500000;
        if (perc > 85) {
          perc = 85;
        }
        if (data.rank === "1") {
          perc = 100;
        } else if (data.rank === "2") {
          perc = 95;
        } else if (data.rank === "3") {
          perc = 90;
        }

        setMilestone({
          a: "100%",
          b: "0%",
          c: "100%",
          d: "0%",
          e: "100%",
          f: "0%",
          g: "100%",
          h: "0%",
          i: perc + "%",
          j: "0%",
          l1: require("./../images/1l-act.svg").default,
          l3: require("./../images/3l-act.svg").default,
          l10: require("./../images/10l-act.svg").default,
          l25: require("./../images/25l-act.svg").default,
        });
      }
      let temp = data;

      let dateBreakupTempData = {
        dmt: 0,
        micro_atm: 0,
        aeps: 0,
        recharge: 0,
        membership: 0,
        bonus: 0,
      };
      let dateRangeBreakupTempData = {
        dmt: 0,
        micro_atm: 0,
        aeps: 0,
        recharge: 0,
        membership: 0,
        bonus: 0,
      };
      let warStatus = localStorage.getItem('war_status');
      localStorage.setItem('month_total', data.month_total);
      setCongratsPoints(warStatus === true ? Math.round(data.month_total/5): Math.round(data.month_total/2));
      if (type === "") {
        setDailyPts(data.month_total);
        setDateRangeBreakup(temp);
        setDateBreakup(temp);
        dateBreakupTempData = temp;
        dateRangeBreakupTempData = temp;
      } else if (type === "1") {
        setDateBreakup(temp);
        dateBreakupTempData = temp;
      } else if (type === "0") {
        setDateRangeBreakup(temp);
        dateRangeBreakupTempData = temp;
      }
      
      setPointsBreakup(temp);
      localStorage.setItem("ami", data.typeCode);
      if(data.targets_data.all_target_completed_status === true){
          setLoader('false');
          // function timeout(delay) {
          //     return new Promise( res => setTimeout(res, delay) );
          // }
          // await timeout(2700);
          OpenCongratulationModal();
      }
      let retImg = 0;
      let saleImg = 0;
      let serviceImg = 0;
      var serviceG = "a.png";
      var retailerG = "a.png";
      var saleG = "a.png";
      let serTra = data.targets_data.service.total_taget;
      if(data.targets_data.service.total_taget < 5){
          serTra = parseInt(data.targets_data.service.total_taget) + 1;
      }
      if (data.targets_data.retailer.completed_status === false) {
        retImg = data.targets_data.retailer.percentage + ".png";
        retailerG = "Green.gif";
      } else {
        retailerG = "greenline.png";
        retImg = data.targets_data.retailer.percentage + ".gif";
      }

      if (data.targets_data.service.completed_status === false) {
        serviceImg = data.targets_data.service.percentage + ".png";
        serviceG = "Blue.gif";
      } else {        
        serviceG = "blueline.png";
        serviceImg = data.targets_data.service.percentage + ".gif";
      }
      if (data.targets_data.sale.completed_status === false) {
        saleImg = data.targets_data.sale.percentage + ".png";
        saleG = "Brown.gif";
      } else {
        saleG = "brownline.png";
        saleImg = data.targets_data.sale.percentage + ".gif";
      }

      setRetailerTargetDisplay(
        <div key="retTargetDiv" className="retTargetDiv">
          <div>
            Target : {data.targets_data.retailer.total_target} retailer
          </div>
          <div>
            Current : {data.targets_data.retailer.completed_target} retailer
          </div>
        </div>
      );
      setServiceTargetDisplay(
        <div key="serTargetDiv" className="serTargetDiv">
          <div>Target : {serTra} service</div>
          <div>
            Current : {data.targets_data.service.completed_target} service
          </div>
        </div>
      );
      setSaleTargetDisplay(
        <div key="saleTargetDiv" className="saleTargetDiv">
          <div className="padding-left">
            Target : ₹ {data.targets_data.sale.total_taget}
          </div>
          {/* <br/> */}
          <div>Current : ₹ {data.targets_data.sale.completed_target}</div>
        </div>
      );
      // url(${require("../images/Astra/"+sale+".gif").default} , url(${require("../images/Astra/"+service+"").default} , url(${require("../images/Astra/"+retailer+"").default} ,

    if(data.targets_data.all_target_completed_status === true){
        setCarausolBackgroundImgStyle(
            {
                backgroundImage: `url(${require("../images/BKB-Elements/FullStone.png").default}) `,
                // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
                backgroundRepeat: "no-repeat",
				marginTop: "-8vh",
        		backgroundSize: "100% 100%"
            }
        );  
        setSaleTargetDisplay("");
        setServiceTargetDisplay("");
        setRetailerTargetDisplay("");
    }else {
        setCarausolBackgroundImgStyle({
            backgroundImage: `url(${
            require("../images/Astra/" + serviceG + "").default
            }) ,url(${require("../images/Astra/" + retailerG + "").default}) ,url(${
            require("../images/Astra/" + saleG + "").default
            }) ,  url(${
            require("../images/Astra/Retailer/R" + retImg + "").default
            }) , url(${
            require("../images/Astra/Sale/S" + saleImg + "").default
            }), url(${
            require("../images/Astra/Service/SE" + serviceImg + "").default
            })`,
            // backgroundSize: "50% 50%, 50% 50%,50% 50%,100% 100%",
            backgroundRepeat:
            "no-repeat,no-repeat,no-repeat,no-repeat,no-repeat,no-repeat",
            marginTop: "-8vh",
            backgroundSize: "100% 100%",
        });
    }

      setLoader("false");
      if (selectedPoints === true && type == 1) {
        dateRangeBreakupTempData = dateRangeBreakup;
      } else if (selectedPoints === false && type == 0) {
        dateBreakupTempData = dateBreakup;
      }
      setSortedDateRangeBreakupHtmlData(
        getDateBreakupHtml(getSortedServicesData(dateRangeBreakupTempData))
      );
      setSortedDateBreakupHtmlData(
        getDateBreakupHtml(getSortedServicesData(dateBreakupTempData))
      );

      //pending services section start
      let pendingServicesHtml = "";
      if (data.pendigServicesNames.length > 0) {
        let picons = [];
        data.pendigServicesNames.forEach((el) => {
          picons.push(
            <img
              className="pendingServicesImage"
              src={
                require("./../images/icons-transaction-pending/" + el + ".png")
                  .default
              }
              alt="pendingServiceImage"
            />
          );
        });
        pendingServicesHtml = (
          <div className="transactions_pending">
            <div className="pending_transaction">
              <span className="text-white" style={{ fontSize: "12px" }}>
                Transactions Pending
              </span>
              <img
                style={{ marginLeft: "5px", height: "16px" }}
                src={
                  require("./../images/icons-transaction-pending/trans_pending.png")
                    .default
                }
                alt="pendingServiceImage"
              />
            </div>
            <div className="pending_transaction_icon">{picons}</div>
          </div>
        );
      }

    }
    if(localStorage.getItem("updateOnB") === "1"){
        // localStorage.setItem("updateOnB", "0");
        const requestOptions = {
            method: 'POST',
            headers: { 'Accept':'*/*','Content-Type': 'application/json','token':token,'userId':user_id },
            body: JSON.stringify({dist_user_id:user_id}),
        };
        const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN+'update-onboarded', requestOptions);
        const data = await response.json();
    }
    if(localStorage.getItem('slide') === "1"){
        slide1.current.click();
    }else {
        slide2.current.click();
    }
  }

  async function setRange2(item) {
    setRange(item);
    localStorage.setItem("pbs", format(item[0].startDate, "yyyy-MM-dd"));
    localStorage.setItem("pbe", format(item[0].endDate, "yyyy-MM-dd"));
    let cnt = localStorage.getItem("clickCnt");
    cnt++;
    localStorage.setItem("clickCnt", cnt);
    if (cnt == 2) {
      setOpen(false);
      localStorage.setItem("d", "0");
      newDateRange();
    }
  }

  async function setDate(item) {
    localStorage.setItem("pbs", format(item[0].startDate, "yyyy-MM-dd"));
    localStorage.setItem("pbe", format(item[0].endDate, "yyyy-MM-dd"));
    localStorage.setItem("d", "1");
    setRange1(item);
    setOpen(false);
    newDateRange();
  }

  const getSortedServicesData = (services_data) => {
    if ("service_data" in services_data) {
      services_data = services_data.service_data;
    }
    const sort = Object.values(services_data).sort((a, b) => b - a);
    const keys = Object.keys(services_data);
    const sortedData = {};
    sort.forEach((val) => {
      keys.forEach((el) => {
        if (services_data[el] === val) {
          sortedData[el] = val;
        }
      });
    });
    return sortedData;
  };

  const getDateBreakupHtml = (sortedServiceData) => {
    console.log('sortedServiceData', sortedServiceData);
    let html = [];
    let uniqueKey = 0;
    Object.keys(sortedServiceData).forEach((keys) => {
      let pointName = keys[0].toUpperCase() + keys.slice(1);
      let image = "";
      if (keys === "bonus") {
        image = require("./../images/" + keys + ".svg").default;
      } else {
        image = require("./../images/" + keys + ".png").default;
      }
      if (keys === "bonus") {
        pointName = "Bonus";
      } else if (keys === "aeps") {
        pointName = keys.toUpperCase();
      } else if (keys === "micro_atm") {
        pointName = "Micro ATM";
      } else if (keys === "dmt") {
        pointName = keys.toUpperCase();
      } else if (keys === "war") {
        pointName = "War Points";
      } else if (keys === "recharge") {
        pointName = "Mobile/DTH Recharge";
      } else if (keys === "dhanakHub") {
        pointName = "Dhanak Hub";
      } else if (keys === "dhanakRefurb") {
        pointName = "Dhanak Refurb";
      } else if (keys === "impact_bonus") {
        pointName = "Impact Bonus";
      } else if (keys === "irctc") {
        pointName = "Irctc";
      } else if (keys === "pan_card") {
        pointName = "Pan Card";
      } else if (keys === "daily_invest") {
        pointName = "Daily Invest";
      } else if (keys === "topup") {
        pointName = "Online Topup";
      } else if (keys === "gatway") {
        pointName = "Payment Gateway";
      } else if (keys === "membership") {
        pointName = "Membership";
      }
      html.push(
        <li key={uniqueKey}>
          <div className="item item-imp">
            <img src={image} alt={`${keys} image`} className="image" />
            <div className="in">
              <div className="point-name">{pointName}</div>
              <span className="text-muted">
                <img
                    src={require("./../images/BKB-Elements/p1.svg").default}
                    alt="alt"
                  /> {" "}
                {sortedServiceData[keys]}
              </span>
            </div>
          </div>
        </li>
      );

      uniqueKey++;
    });
    return html;
  };

  //Final Home Page
  //ref
  let RankModalRef = useRef(null);
  let CongratulationModalRef = useRef(null);
  let Claim2xRef = useRef(null);
  let congratsPointsRef = useRef(null);
  let closeCongratulationPopupRef = useRef(null);
  // style using hook

  let [backgroundImgStyle, setBackgroundImgStyle] = useState({
    backgroundImage: ` url(${impactPlayerBackgroundImage})`,
    backgroundRepeat: "no-repeat,no-repeat,no-repeat repeat-y",
  });
  let [carausolBackgroundImgStyle, setCarausolBackgroundImgStyle] = useState();

  let [myRankTopBarStyle, setMyRankTopBarStyle] = useState({
    backgroundImage: `url(${myRankBGImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
  });

  let [leaderboardStyle, setLeaderboardStyle] = useState({
    color: "#fff",
  });
  const congratsStyle = {
    backgroundImage : `url(${require("../images/Impact_player_screen/CompletedAstra/with_text.png").default})`,
    backgroundRepeat :"no-repeat",
    backgroundSize : "100% 100%",
    backgroundColor : "rgb(39 37 37 / 90%)",
  }
  const [fullStone, setFullStone] = useState(null);
  const [selectedPoints, setSelectedPoints] = useState(null);
  const [congratStyle, setCongratStyle] = useState(congratsStyle);
  // custom function
  const OpenRankModal = (flag) => {
    loadLeaderboardComponent(flag);
    RankModalRef.current.click();
  };

  function OpenCongratulationModal() {
    setTimeout(() => CongratulationModalRef.current.click(), 1000);
  }

  function Claim2x() {
    setCongratsPoints(localStorage.getItem('month_total'));
    congratsStyle.backgroundImage =  `url(${require("../images/Impact_player_screen/CompletedAstra/with_text.png").default}),url(${require("../images/Impact_player_screen/home_screen/Points_being_collected.gif").default})`;
    congratsStyle.backgroundRepeat = "no-repeat,no-repeat";
    setTimeout(() => setCongratStyle(congratsStyle))
    setTimeout(() => {
      congratsPointsRef.current.style.display = "none";
      setCongratStyle({
        backgroundImage : `url(${require("../images/Impact_player_screen/CompletedAstra/blank.png").default})`,
        backgroundRepeat :"no-repeat",
        backgroundSize : "100% 100%",
        backgroundColor : "rgb(39 37 37 / 90%)",
      });
      setFullStone(
        <div style={{top:"20%"}} className="target_completed text-center">
          <img
            src={
              require("./../images/Impact_player_screen/home_screen/movingFullStone.gif")
                .default
            }
          />
        </div>
      )
    }, 1400);

    setTimeout(() => closeCongratulationPopupRef.current.click(),4000);
    setTimeout(() => Claim2xRef.current.style.display = "none", 1000);
  }

  async function closeCongratulationPopup() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
        userId: user_id,
      },
      body: JSON.stringify({
        dist_user_id: user_id,
        val: pointsBreakup.typeCode,
      }),
    };
    const response = await fetch(
      process.env.REACT_APP_BKB_URL_DOMAIN + "update-dist-animation-status",
      requestOptions
    );
    await response.json();
  }

  const loadLeaderboardComponent = (isDailyPointsSelected) => {
    const style = {
      bg: {
        backgroundImage: `url(${myRankBGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        color: "#fff",
      },
      color: { color: "#fff" },
    };
    setSelectedPoints(isDailyPointsSelected);
    if (isDailyPointsSelected) {
      setMyRankTopBarStyle(style.bg);
      setLeaderboardStyle(style.color);
    } else {
      setMyRankTopBarStyle(style.color);
      setLeaderboardStyle(style.bg);
    }
  };

  const [isPointsVisible, setPointsVisibility] = useState(false);

  const togglePointsVisibility = () => {
    setPointsVisibility(!isPointsVisible);
  };

  return (
    <>
      <Helmet
        link={[{ rel: "stylesheet", href: "css/ImpactPlayerPage.css" }]}
      />
      <div className="row no-gutters">
        {loader === "true" && (
          <div className="application bg-greyis" id="loading"></div>
        )}
        {loader === "false" && (
          <div className="bg-bkb-img application sc" style={backgroundImgStyle}>
            
            <div className="bg-bkb-img sc page-1">
              <div className="backAndProfile">
                <div className="goBack">
                  <a onClick={() => history.goBack()}>
                    <img
                      alt=""
                      src={
                        require("./../images/Impact_player_screen/home_screen/ArrowBack.png")
                          .default
                      }
                      className="img-fluid backIcon"
                      style={{display : "none"}}
                    />
                  </a>
                </div>
                <div className="profile">
                  {pointsBreakup.dist_profile_pic !== "" && (
                    <img
                      style={{
                        width: "75%",
                        height: "100%",
                        borderRadius: "50%",
                        padding: "5%",
                      }}
                      alt=""
                      src={pointsBreakup.dist_profile_pic}
                      className="img-fluid profile_image"
                    />
                  )}
                </div>
              </div>
			  <Link to="/welcome-iw">
				<div className='time-left'>
					<div className='time-left-header'>
          Rising Distributors benefits ends in
					</div>
					<div className='time-left-timer-num'>
						{timerComponents}
					</div>
				</div>
				</Link>
              <div className="astra-section">
                <div
                  id="carouselExampleControls" className="carousel slide carousel-size" data-touch="true" data-ride="carousel" data-interval="false" >
                  <ol className="carousel-indicators">
                    <li ref={slide1} key="si1" data-target="#carouselExampleControls" data-slide-to="0" className="active" ></li>
                    <li ref={slide2} key="si2" data-target="#carouselExampleControls" data-slide-to="1" ></li>
                  </ol>
                  <div className="carousel-inner" role="listbox">
                    {/* 1st slide */}
                    <div key="s1" className="active carousel-item bkb">
                      <div
                        className="align-items-center justify-content-center min-vh-100"
                        style={carausolBackgroundImgStyle}
                      >
                        <div className="pos-relative">
                          {retailerTargetDisplay}
                          {serviceTargetDisplay}
                        </div>
                        {saleTargetDisplay}
                      </div>
                    </div>
                    { slideMarker === '1' && (
                                <Link to={{
                                    pathname:"/region-home"
                                }} className="carousel-item bkb">
                                    <div
                                        className="align-items-center justify-content-center slide_3"
                                        style={{
                                        backgroundImage: `url(${
                                            require("../images/Impact_player_screen/Onboarding_screen/two_days_back.png")
                                            .default
                                        })`,
                                        backgroundSize: "100% 100%",
                                        }}
                                    >
                                        <div className="battle_no text-white text-center" style={{paddingTop : "6vh"}}>BATTLE NO. {warData.battle_no} </div>
                                        <div className='teams'>
                                            <div className="team_1 text-white text-center">
                                            <span>{warData.kd1_name}</span>
                                            </div>
                                            <div style={{width:'20%'}}></div>
                                            <div className="team_2 text-white text-center"><span>{warData.kd2_name}</span> </div>
                                        </div>
                                        <div className="timers text-white text-center">
                                        <span>{timerComponents2}</span>
                                        </div>
                                    </div>
                                </Link>
                            )}
                            {secondSlide}

                  </div>
                </div>
              </div>
              <div className="parent-sec">
                <div className="points-section">
                <img
                    className="stamp2x"
                    src={require(`./../images/Impact_player_screen/home_screen/stamp_${warStatus === true ? "5x": "2x"}.gif`).default}
                    alt="alt"
                  />
                  <div className="points-div">
                    <div className="pay1_points" onClick={() => OpenRankModal(true)}>
                      <i className="points-text">Today's Points</i>
                      <br />
                      <img
                        src={require("./../images/BKB-Elements/p1.svg").default}
                        alt="alt"
                      />{" "}
                      <span>{dailyPts}</span>
                    </div>
                    <div className="pay1_points" onClick={() => OpenRankModal(false)}>
                      <i className="points-text">Total Points</i>
                      <br />
                      <img
                        src={require("./../images/BKB-Elements/p1.svg").default}
                        alt="alt"
                      />{" "}
                      <span>{pointsBreakup.total_points}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  isPointsVisible ? "parent displayBlock" : "parent displayNone"
                }
              >
                <div className="ptsJorneyCont">
                  <div className="points-journey-bar">
                    <div className="bar-sect bar-sect-1">
                      <div
                        className="left-side-bar left-side-bar-first"
                        style={{ width: `${milestone.a}` }}
                      >
                        &nbsp;
                      </div>
                      <div
                        className="right-side-bar"
                        style={{ width: `${milestone.b}` }}
                      >
                        &nbsp;
                      </div>
                      <div className="side-bar-icon">
                        <img src={milestone.l1} />
                      </div>
                      <div className="side-bottom-bar-icon">
                        <img
                          src={
                            require("./../images/3000-gift-voucher.svg").default
                          }
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="bar-sect bar-sect-2">
                      <div
                        className="left-side-bar"
                        style={{ width: `${milestone.c}` }}
                      >
                        &nbsp;
                      </div>
                      <div
                        className="right-side-bar"
                        style={{ width: `${milestone.d}` }}
                      >
                        &nbsp;
                      </div>
                      <div className="side-bar-icon">
                        <img src={milestone.l3} />
                      </div>
                      <div className="side-bottom-bar-icon">
                        <img
                          src={
                            require("./../images/10000-gift-voucher.svg")
                              .default
                          }
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="bar-sect bar-sect-3">
                      <div
                        className="left-side-bar"
                        style={{ width: `${milestone.e}` }}
                      >
                        &nbsp;
                      </div>
                      <div
                        className="right-side-bar"
                        style={{ width: `${milestone.f}` }}
                      >
                        &nbsp;
                      </div>
                      <div className="side-bar-icon">
                        <img src={milestone.l10} />
                      </div>
                      <div className="side-bottom-bar-icon">
                        <img
                          src={require("./../images/5gm-gold-coin.svg").default}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="bar-sect bar-sect-4">
                      <div
                        className="left-side-bar"
                        style={{ width: `${milestone.g}` }}
                      >
                        &nbsp;
                      </div>
                      <div
                        className="right-side-bar"
                        style={{ width: `${milestone.h}` }}
                      >
                        &nbsp;
                      </div>
                      <div className="side-bar-icon">
                        <img src={milestone.l25} />
                      </div>
                      <div className="side-bottom-bar-icon">
                        <img
                          src={
                            require("./../images/10gm-gold-coin.svg").default
                          }
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="bar-sect bar-sect-5">
                      <div
                        className="left-side-bar"
                        style={{ width: `${milestone.i}` }}
                      >
                        &nbsp;
                      </div>
                      <div
                        className="right-side-bar"
                        style={{ width: `${milestone.j}` }}
                      >
                        &nbsp;
                      </div>
                      <div className="side-bar-right-icon">
                        <img
                          src={require("./../images/bkb3-gifts.png").default}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="Expandable-points"
                onClick={togglePointsVisibility}
              >
                <i className="text-white">
                  <img
                    src={require("./../images/BKB-Elements/p1.svg").default}
                    alt="alt"
                  />&nbsp;
                  {achievingMilestone.acheive} more to win {achievingMilestone.voucher}.Click to {isPointsVisible ? "close" : "view"}
                </i>
              </div>
              <div className="impact-player_ranking">
                <div className="impact-player-ranking-card">
                <a className='impact_player_ranking_btn btn btn-default text-white'>Rising Distributors Ranking</a>
                  <ImpactPlayerLeaderboard />
                </div>
              </div>
            </div>
          </div>
        )}
        {loader === "error" && <Redirect to="/" />}
        <div className="bg"></div>
      </div>

      {/* show error msg popup */}
      <a data-toggle="modal" ref={inputRef} data-target="#bottom_modal"></a>
      <div
        className="modal bottom fade"
        id="bottom_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="bottom_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div
              className="modal-header border-0 px-26 text-center d-block"
              style={{ height: `50px` }}
            >
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{ opacity: `1`, position: `relative`, top: `-20px` }}
              >
                <img
                  src={require("./../images/close.png").default}
                  alt="close"
                  className="img-fluid"
                />
              </button>
            </div>
            <div className="modal-body px-34">
              <p className="mb-0 text-black">{desc}</p>
              <div className="row justify-content-center my-3"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Rank modal */}
      <a data-toggle="modal" ref={RankModalRef} data-target="#rank_modal"></a>
      <div
        className="modal bottom fade"
        id="rank_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="rank_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="image-section">
               <img style={{width:"100%"}} src={require(`./../images/Impact_player_screen/home_screen/${warStatus === true ? "war_day_bg": "misile"}.gif`).default}/>
            </div>
            <div className="modal-header rankModalHeader border-0 px-26 d-block" style={{padding:"0rem",marginTop:"1vh",marginBottom:"1vh"}}>
              <div className="rank-modal-header">
                <div className="my-rank">
                  <button
                    className="my_rank_text text-center"
                    style={myRankTopBarStyle}
                    onClick={() => loadLeaderboardComponent(true)}
                  >
                    TODAY'S POINTS
                  </button>
                </div>
                <div className="leaderboard">
                  <button
                    className="leaderboard_text text-center"
                    style={leaderboardStyle}
                    onClick={() => loadLeaderboardComponent(false)}
                  >
                    TOTAL POINTS
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body px-34 totalPointsModalBody" style={{padding:"0rem"}}>
              <div className={selectedPoints === false ? "displayBlock total-points-div" : "displayNone total-points-div"}>
                <div
                  className="dropdown pl-1"
                  style={{
                    display: "inline-block",
                    backgroundColor: "#33302E",
                    width: "60%",
                  }}
                >
                  <div
                    className="inputBox"
                    onClick={() => setOpen((open) => !open)}
                  >
                    <i className="fa fa-calendar calendarIcon"></i>
                    <span className="date-str-cont">{`${format(
                      range[0].startDate,
                      "yyyy-MM-dd"
                    )} to ${format(range[0].endDate, "yyyy-MM-dd")}`}</span>
                  </div>

                  <div
                    ref={refOne}
                    style={{
                      zIndex: 10000,
                      position: "fixed",
                      display: "inline-block",
                      top: "50%",
                      left: "50%",
                      margin: "auto",
                      transform: `translate(-50%, -50%)`,
                    }}
                  >
                    {open && (
                      <DateRange
                        onChange={(item) => setRange2([item.selection])}
                        minDate={miDate}
                        maxDate={maDate}
                        moveRangeOnFirstSelection={false}
                        ranges={range}
                        months={1}
                        direction="horizontal"
                        className="calendarElement"
                      />
                    )}
                  </div>
                </div>
                <div
                  className="right "
                  style={{ float: "right", color: "#fff", fontWeight: "500", width : "35%" }}
                >
                    <span className="popupClassPoints"><img
                        src={require("./../images/BKB-Elements/p1.svg").default}
                        alt="alt"
                      />  {" "+dateRangeBreakup.month_total}</span>
                </div>
              </div>
              <div className={selectedPoints === true ? "displayBlock daily-points-div" : "displayNone daily-points-div"}>
                <div
                  className="dropdown pl-1"
                  style={{
                    display: "inline-block",
                    backgroundColor: "#33302E",
                    width: "38%",
                  }}
                >
                  <div
                    className="inputBox"
                    onClick={() => setOpen((open) => !open)}
                  >
                    <i className="fa fa-calendar calendarIcon"></i>
                    <span className="date-str-cont">{`${format(
                      range1[0].startDate,
                      "yyyy-MM-dd"
                    )}`}</span>
                  </div>

                  <div
                    ref={refOne}
                    style={{
                      zIndex: 10000,
                      position: "fixed",
                      display: "inline-block",
                      top: "50%",
                      left: "50%",
                      margin: "auto",
                      transform: `translate(-50%, -50%)`,
                    }}
                  >
                    {open && (
                      <DateRange
                        onChange={(item) => setDate([item.selection])}
                        ranges={range1}
                        months={1}
                        direction="horizontal"
                        className="calendarElement"
                      />
                    )}
                  </div>
                </div>
                <div
                  className="right w-30"
                  style={{ float: "right", color: "#fff", fontWeight: "500" }}
                >
                    <span className="popupClassPoints"><img
                        src={require("./../images/BKB-Elements/p1.svg").default}
                        alt="alt"
                      /> {" "+dateBreakup.month_total}</span>
                </div>
              </div>
              <ul className="listview image-listview points-list">
                {selectedPoints === true ? sortedDateBreakupHtmlData : sortedDateRangeBreakupHtmlData}
              </ul>
            </div>
          </div>
          <div className="backtohome">
            <img style={{cursor:"pointer"}} src={require("./../images/Impact_player_screen/home_screen/Back_to_Home.png").default}/>
          </div>
        </div>
      </div>

      {/* Congratulation modal */}
      <a
        data-toggle="modal"
        ref={CongratulationModalRef}
        data-target="#congratulation_modal"
      ></a>
      <div
        className="modal bottom fade"
        id="congratulation_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="congratulation_modal"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={congratStyle}>
            <div className="modal-body px-34">
            <button ref={closeCongratulationPopupRef} type="button" className="close" data-dismiss="modal" aria-label="Close" style={{display:"none"}} onClick={closeCongratulationPopup}></button>
              <div ref={congratsPointsRef} className="congrats-points text-center">
                      {congratsPoints}
              </div>
              <div className="target_image">
                  
                {fullStone}
              </div>

              <div className="okBtn text-center mt-2">
                <button
                  ref={Claim2xRef}
                  type="button"
                  className="close"
                  aria-label="Close"
                  style={{ opacity: `1`, position: `relative`, float: `none` }}
                  onClick={Claim2x}
                >
                  <img
                    style={{width:"40%"}}
                    src={
                      require("./../images/Impact_player_screen/home_screen/claim_2x.png").default
                    }
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImpactPlayerPage;
